<template>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-card class="elevation-12">
            <v-toolbar dark color="primary">
              <v-toolbar-title>
                <span>Error de acceso</span>
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-alert text color="info" elevation="0" class="ma-5" >
                El usuario no tiene permitido el acceso al control de fichajes.
                <br />Por favor, comuniquese con el administrador del sistema para que se lo habilite.
                <v-divider class="my-4 info" style="opacity: 0.22"></v-divider>
  
                <v-row align="center" no-gutters>
                  <v-col class="grow">Perdone las molestias</v-col>
                  <v-spacer></v-spacer>
                  <v-col class="shrink">
                    <v-btn color="info" outlined @click="reintentar">Reintentar</v-btn>
                  </v-col>
                </v-row>
              </v-alert>
            </v-card-text>
          </v-card>
          <v-snackbar v-model="showError" color="error" :timeout="8000" right>
            {{ mensajeError }}
            <v-btn dark text @click="showError = false">Cerrar</v-btn>
          </v-snackbar>
        </v-flex>
      </v-layout>
    </v-container>
  </template>
  <script>
  import { mapState } from "vuex";
  import globalService from "@/services/globalService.js";
  import authenticationService from "@/services/authenticationService.js";
  import ayuda from "@/components/commons/ayuda";
  export default {
    data() {
      return {
        mensajeError: "El usuario no tiene permitido el acceso al control de fichajes.",
        showError: false
      };
    },
    computed: {
      ...mapState("authentication", ["status", "user"])
    },
    watch: {
    },
    components: { ayuda },
    created() {},
    mounted() {
    },
    methods: {
      reintentar: function() {
        this.$router.push("/login");  
    }
    }
  };
  </script>
  